"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcCardSliderContainer = exports.cardMargin = void 0;
var react_1 = __importDefault(require("react"));
exports.cardMargin = 5;
var AcCardSliderContainer = function (_a) {
    var cards = _a.cards, _b = _a.sliderLeft, sliderLeft = _b === void 0 ? 0 : _b, sliderContainerRef = _a.sliderContainerRef, sliderRef = _a.sliderRef, children = _a.children;
    /**
     * Disable user select on card to prevent dragging issue
     */
    var renderCards = function () {
        if (cards && cards.length > 0) {
            return cards.map(function (card, index) {
                return (react_1.default.createElement("div", { key: "SliderCard:" + index, className: "position-relative", style: {
                        marginLeft: index > 0 ? exports.cardMargin : 0,
                        marginRight: index < cards.length - 1 ? exports.cardMargin : 0,
                    } }, card));
            });
        }
        return undefined;
    };
    return (react_1.default.createElement("div", { ref: sliderContainerRef, className: "w-100 position-relative", style: { overflow: 'hidden', height: 80, display: children ? 'block' : 'none' } },
        react_1.default.createElement("div", { ref: sliderRef, className: "d-flex position-absolute", style: { top: 0, left: sliderLeft } }, renderCards()),
        children));
};
exports.AcCardSliderContainer = AcCardSliderContainer;
exports.AcCardSliderContainer.displayName = 'AcCardSliderContainer';
//# sourceMappingURL=AcCardSliderContainer.js.map